import { trigger, state, style, transition, animate, AnimationTriggerMetadata } from '@angular/animations';

export function fadeOut(durationMs: number): AnimationTriggerMetadata {
	return trigger('fadeOut', [
		state('*', style({ opacity: 1 })),
		state('void', style({ opacity: 0 })),
		transition(':leave', animate((durationMs || 0) + 'ms ease-in-out'))
	]);
}

export function fadeIn(durationMs: number): AnimationTriggerMetadata {
	return trigger('fadeIn', [
		state('*', style({ opacity: 1 })),
		state('void', style({ opacity: 0 })),
		transition(':enter', animate((durationMs || 0) + 'ms ease-in-out'))
	]);
}

export function slideUp(durationMs: number): AnimationTriggerMetadata {
	return trigger('slideUp', [
		state('*', style({ 'max-height': '100%' })),
		state('void', style({ height: 0 })),
		transition(':enter', animate((durationMs || 0) * 2 + 'ms ease-in-out'))
	]);
}

export function slideDown(durationMs: number): AnimationTriggerMetadata {
	return trigger('slideDown', [
		state('*', style({ 'max-height': '100%' })),
		state('void', style({ height: 0 })),
		transition(':leave', animate((durationMs || 0) * 2 + 'ms ease-in-out'))
	]);
}

// ===== Specific animations

export function appLoaderAnimation(durationMs: number = 0, delayMs: number = 0): AnimationTriggerMetadata {
	return trigger('appLoaderAnimation', [
		state('void', style({ transform: 'translateY(-200%)' })),
		state('*', style({ transform: 'translateY(0)' })),

		// duration multiplied by 2 because translateY goes to -200%, not -100%
		transition(':leave', animate(`${durationMs * 2}ms ${delayMs}ms ease-in-out`))
	]);
}

